import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';

export default function Header({ title, justText, onClick}) {
  return (
    <div className='settings-chip'>
        <div>
            <icons.CaretLeftFill/>
            {title}
        </div>
        {
            !justText &&
            <CButton
                text={`ذخیره ${title}`}
                icon={<icons.Save2 />}
                onClick={onClick}
                className='setting-btn'
            />
        }
    </div>
  );
}